<template>
    <v-image-file-field
            label="Upload File"
            name="file"
            @input="handleInput"
        />
</template>

<script>
    export default {
        methods: {
            handleInput()
            {
                window.location.href = '/files'
            }
        }
    }
</script>